import { getWebAppBaseUrl } from '@/utils/webAppUrl';

/** Public web URL for sharing an event invite link. */
export function buildEventInviteLink(eventId: string): string {
  return `${getWebAppBaseUrl()}/#/invite?event=${encodeURIComponent(eventId)}`;
}
